"use client";

import { useAuth } from "@clerk/nextjs";
import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

// 브라우저 Sentry 이벤트에 로그인 사용자의 Clerk ID만 붙인다.
// 고객 문의 조사 때 사용자 단위로 오류를 찾기 위한 용도이며, 이메일·이름은 넣지 않는다.
export default function SentryUserContext() {
  const { isLoaded, userId } = useAuth();

  useEffect(() => {
    if (!isLoaded) return;
    Sentry.setUser(userId ? { id: userId } : null);
  }, [isLoaded, userId]);

  return null;
}
